export default {
  'Start at': 'Begin bij',
  'Set to current time': 'Instellen op huidige tijd',
  'Audio volume': 'Audio volume',
  'Video volume': 'Video volume',
  'Trim audio': 'Audio bijsnijden',
  'Audio will end with the video': 'Audio zal eindigen met de video.',
  'Trim': 'Trimmen',
}